<template>
  <div>
    <b-form-select
      v-model="selected"
      :options="options"
      :state="true"
    >
    <b-form-select-option value="" disabled>-- Por favor, elija un destinatario --</b-form-select-option>
    </b-form-select>
     <div v-if="!value"><b-badge variant="primary">Seleccione un destinatario. </b-badge></div>
  </div>
</template>

<script>
import { insuranceClaimsService } from "@/_services";
export default {
  props: {
    value: null
  },
  data() {
    return {
      selected: this.value,
      options: [],
    };
  },
  watch: {
     selected (value) {
       this.$emit('input', value)
     },
     value (value) {
       this.selected = value
     }
  },
  async mounted() {
    var employeesList = await insuranceClaimsService.getEmployees();
    this.options = [];
    employeesList.forEach((element) => {
      this.options.push({
        value: element.email,
        text: element.nombre,
      });
    });
  },
};
</script>

<style>
.badge {
    color: #fff;
    background-color: #ff3333 !important;
}
</style>